/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'
import { BulletList } from 'react-content-loader'

import '../../../ShopList/list.scss'

import { useNavigate } from 'react-router-dom'

import { ToRial } from '../../../../services/toRial'

export default function index(data, shop) {
  const [offCode, setOffCode] = useState([])
  const navigate = useNavigate()

  useEffect(() => {
    setOffCode(data.data)
  }, [data])

  return (
    <>
      <table className='table'>
        <thead>
          <tr>
            <th>نام کد تخفیف</th>
            <th>تعداد سفارش</th>
            <th>مبلغ خرید</th>
            <th>گرید</th>
            <th>عملیات</th>
          </tr>
        </thead>
        <tbody>
          {offCode ? offCode.map(item => 
              item.shop[0] == data.shop ?
              (<tr key={item._id}>
                <td>{item.name}</td>
                <td>{ToRial(item.price) + ' تومان '}</td>
                <td>{item.level}</td>
                <td>
                  <button onClick={() => navigate(`/foods/edit/${item._id}`)}>ویرایش</button>
                </td>
              </tr>) : '') : <tr><td colSpan="5"><BulletList rtl style={{ width: '30%', rowspan: '5' }}/></td></tr>}
        </tbody>
      </table>
    </>
  );
}
